export default __webpack_public_path__ + "static/media/Environment-02.4b45ddac.jpg";